import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const AdminOLogoInverse32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1406 1025q0 26-10 49t-27 40-40 27-49 10V898q26 0 49 10t40 27 27 41 10 49zm611 84l-63 239-209-28q-17 26-36 50t-40 46l73 190-213 124-127-166q-60 13-122 15v-209q71 0 134-27t110-73 74-110 27-134q0-72-27-134t-74-110-110-74-134-27V467h5l79-178 238 63-26 203q26 17 51 37t47 43l186-71 124 213-166 127q6 28 9 56t4 57v10l186 82zM628 1279q-42 0-72-27t-48-65-27-82-9-77q0-33 8-76t27-82 49-65 72-27q42 0 72 26t48 65 27 82 9 77q0 33-8 76t-27 83-49 65-72 27zM64 272L1216 67v1914L64 1782V272zm575 356q-50 0-92 17t-75 48-59 70-43 84-25 91-9 90q0 43 8 89t26 91 42 84 59 70 76 48 92 18q75 0 132-38t95-97 57-129 19-136q0-65-19-135t-57-130-95-97-132-38z" />
    </svg>
  ),
  displayName: 'AdminOLogoInverse32Icon',
});

export default AdminOLogoInverse32Icon;
